module.exports = __webpack_public_path__ + "img/img15.53f439d2.jpg";